module.exports = __webpack_public_path__ + "img/logo.50546e09.png";